import React from 'react';
import { Skeleton } from 'antd';
import CardContainer from '../CardContainer';
import Wrapper from '../Wrapper';

const ParagraphWithHeadingSkeleton: React.FC = () => {
  return (
    <CardContainer>
      <Wrapper mb={1} display="flex" alignItems="center">
        <Wrapper mr={1}>
          <Skeleton round active />
        </Wrapper>
        <Skeleton round active paragraph={{ rows: 4 }} />
      </Wrapper>
    </CardContainer>
  );
};

export default ParagraphWithHeadingSkeleton;
